import { Box, SxProps, Tabs, TabsProps, Theme } from "@mui/material";

type Props = TabsProps & {
  /** Outer spacing around the tab bar. Defaults to section-page spacing. */
  dense?: boolean;
  containerSx?: SxProps<Theme>;
};

/**
 * Horizontally scrollable section sub-tabs for dashboard pages.
 * Keeps tab labels from forcing the page wider than the viewport on mobile.
 */
const SectionTabs = ({
  children,
  sx,
  dense = false,
  containerSx,
  ...props
}: Props) => {
  return (
    <Box
      sx={[
        {
          borderBottom: 1,
          borderColor: "divider",
          margin: dense
            ? { xs: "12px 0", md: "16px 0" }
            : { xs: "16px 0", md: "32px 0" },
          maxWidth: "100%",
          overflow: "hidden",
        },
        ...(Array.isArray(containerSx) ? containerSx : [containerSx]),
      ]}
    >
      <Tabs
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={[
          {
            minHeight: { xs: 40, md: 48 },
            "& .MuiTabs-flexContainer": {
              gap: { xs: 0.5, md: 0 },
            },
            "& .MuiTab-root": {
              minHeight: { xs: 40, md: 48 },
              minWidth: "auto",
              px: { xs: 1.5, md: 2 },
            },
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
        {...props}
      >
        {children}
      </Tabs>
    </Box>
  );
};

export default SectionTabs;
